<script>
    import { preventDefault } from "svelte/legacy";

    import { createEventDispatcher } from "svelte";
    import tagService from "../service.js";
    import { flatten422Errors } from "../../../services/api.svelte.js";
    import { translateErrorMessages } from "../../../services/api.svelte.js";
    import SearchResults from "../../../components/search-results.svelte";
    import AssetsApi from "../../asset/assets.api.js";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    let { tag, limits, parent } = $props();

    let formData = $state({});
    let formDataPromise;
    let formIsSubmitted = false;
    // API string errors
    let APIerror = $state(null);
    let tagRegexError = null;
    // API 422 errors
    let formApiErrors = {};
    let assets = $state([]);
    let assets_are_loading = $state(false);
    let search_results = $state();
    let search_result = $state("");
    let showDropdown = $state(false);
    let has_searched_once = $state(false);
    let assetsToAssociate = $state([]);
    let assetsToRemove = [];
    let assetsAssociated = $state([]);
    let assetKind = $state();
    let is_edit;

    // add form
    if (!tag) {
        formDataPromise = Promise.resolve({});
        is_edit = false;
    }
    // edit form
    else {
        formData = {
            name: tag.name,
        };
        is_edit = true;
        if (!tag.assets && tag.asset) {
            assetsAssociated =
                typeof tag.asset === "string"
                    ? JSON.parse(tag.asset)
                    : tag.asset;
        } else if (tag.assets && !tag.asset) {
            assetsAssociated = JSON.parse(tag.assets);
        } else {
            assetsAssociated = [];
        }
    }

    const handleAssetInput = async (e) => {
        if (e.target.value == "none") return;
        let kind = e.target.value;
        assets = await getAssets(kind);
        assets = assets;
        search_results = assets;
        has_searched_once = true;
    };

    const getAssets = async (kind) => {
        assets_are_loading = true;
        assets = await AssetsApi.fetchAssets("v2/asset/", {
            filter: { kind: kind },
        });
        assets_are_loading = false;
        showDropdown = true;
        return assets;
    };

    function containsUppercase(str) {
        return /[A-Z]/.test(str);
    }

    function handleSubmit() {
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        if (containsUppercase(formData.name))
            return (tagRegexError = $format("page.tag.invalid_characters"));

        tagService
            .save(formData, [])
            .then(async (savedTag) => {
                if (assetsToAssociate.length > 0) {
                    for (let asset of assetsToAssociate) {
                        let reqData = {
                            tag_id: savedTag.id,
                            target_object_type: "Asset",
                            target_object_id: asset.id,
                        };
                        await tagService.saveAssociation(reqData, [], {});
                    }
                }

                dispatch("save", { savedTag });
                //clear formData and form status and errors
                // when modal is closed after sending add request
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {};
                return true;
            })
            .catch((errors) => {
                if (typeof errors.detail == "string") {
                    APIerror = translateErrorMessages(
                        errors.detail,
                        $format("page.tag.title"),
                    );
                } else {
                    // parse API errors
                    formApiErrors = flatten422Errors(errors);
                }

                return false;
            });
    }

    const handleSearch = (e) => {
        showDropdown = true;
        search_results = assets;
        let searchValue = e.target.value;
        search_results = search_results.filter((sr) =>
            sr.name
                ? sr.name.includes(searchValue)
                : sr.nickname.includes(searchValue),
        );
        search_results = search_results;
    };

    const containsObject = (obj, list) => {
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i].id === obj.id) {
                return true;
            }
        }
        return false;
    };

    const selectAsset = (e) => {
        let asset = e.detail;
        formData.asset_id = asset.id;
        //showDropdown = false;
        search_result = asset.name;

        if (!containsObject(asset, assetsToAssociate)) {
            assetsToAssociate.push(asset);
        }
        assetsToAssociate = assetsToAssociate;
        //assets = assets.filter(item=> item.id != asset.id);
        //@TODO: remove/mark selected assets on search panel
    };

    const removeAssetToAssociate = (i) => {
        assetsToRemove.push(assetsToAssociate[i]);
        assetsToAssociate.splice(i, 1);
        assetsToAssociate = assetsToAssociate;
    };

    function handleCloseModal() {
        formData = {};
        formApiErrors = {};
        formIsSubmitted = false;
        formIsSubmitted = false;
        showDropdown = true;
        APIerror = null;
        assetKind = null;
        assets = [];
        search_results = [];
        assetsToAssociate = [];
    }

    const handleKeydown = (event) => {
        if (event.key == "Escape") {
            handleCloseModal();
        } else {
            return;
        }
    };
</script>

<svelte:window onkeydown={handleKeydown} />

<form role="form" novalidate onsubmit={preventDefault(handleSubmit)}>
    <div class="card">
        <div class="card-body" style="position: relative;">
            {#if tag}
                <div class="mb-3">
                    <label for="name"
                        >{$format("list.columns.name")}<span
                            title={$format("required")}
                            class="text-danger">*</span
                        ></label
                    >
                    <span class="d-block">{tag.name}</span>
                </div>
            {/if}
            <div class="mb-3">
                <label for="name"
                    >{$format("associate")} {$format("asset.word")}:</label
                >
                <select
                    id="tagFormAssetType"
                    class="form-control t-tag-select-asset-kind"
                    oninput={handleAssetInput}
                    bind:value={assetKind}
                >
                    <option value="none"
                        >{$format(
                            "components.advancedSearch.asset_kind",
                        )}</option
                    >
                    <option value="domain"
                        >{$format("asset.kind.domain.singular")}</option
                    >
                    <option value="hostname">Hostname</option>
                    <option value="public_network"
                        >{$format("asset.kind.public_network.singular")}</option
                    >
                    <option value="public_ip"
                        >{$format("asset.kind.public_ip.singular")}</option
                    >
                    <option value="private_ip"
                        >{$format("asset.kind.private_ip.singular")}</option
                    >
                    {#if limits.active_directory_limit > 0}<option value="ad"
                            >{$format("asset.kind.ad.singular")}</option
                        >{/if}
                    {#if limits.cloud_limit > 0}<option value="cloud"
                            >{$format("asset.kind.cloud.singular")}</option
                        >{/if}
                    {#if limits.source_code_limit > 0}<option value="software"
                            >{$format("asset.kind.software.singular")}</option
                        >{/if}
                    {#if limits.endpoint_limit > 0}<option value="endpoint"
                            >{$format("asset.kind.endpoint.singular")}</option
                        >{/if}
                </select>
                {#if APIerror}
                    <div class="mt-3 text-danger" style="font-size: 80%;">
                        {APIerror}
                    </div>
                {/if}
            </div>

            <div class="mb-3">
                {#if assets.length}
                    <div>
                        <span>{$format("search")} {$format("asset.word")}</span>
                        <span style="position: relative;">
                            {#if assets_are_loading}
                                <i class="fa fa-spin fa-sync-alt"></i>
                            {:else}
                                <input
                                    class="form-control t-tag-select-asset"
                                    type="text"
                                    oninput={handleSearch}
                                    placeholder={$format("search")}
                                    bind:value={search_result}
                                    style="text-indent: 20px;"
                                />
                                <i
                                    class="fas fa-search"
                                    style="position: absolute; left: 5px; top: 2px; color: #0000003d;"
                                ></i>
                            {/if}
                        </span>
                        <SearchResults
                            elements={search_results}
                            {showDropdown}
                            element_being_selected={"activo"}
                            on:selectElement={selectAsset}
                            on:closeSearchPanel={() => (showDropdown = false)}
                        />
                    </div>
                {/if}
                {#if !assets_are_loading && assets.length < 1 && has_searched_once}
                    <div>{$format("results_not_found")}</div>
                {/if}
                <select
                    id="tagFormAsset"
                    class="form-control d-none"
                    bind:value={formData.asset_id}
                    style="max-width: 318px; margin-top: 1em;"
                >
                    <option value="none"
                        >{$format("form.fields.select")}...</option
                    >
                    {#if !assets_are_loading}
                        {#each assets as asset}
                            <option value={asset.id}
                                >{asset.nickname || asset.name}</option
                            >
                        {/each}
                    {/if}
                </select>
            </div>
            {#if !parent || parent != "detail"}
                <label for="associatedAssets"
                    >{$format("page.tag.associated_assets")}:</label
                >
                {#if assetsAssociated.length}
                    {#each assetsAssociated as asset, i}
                        <div>{asset.nickname || asset.name}</div>
                    {/each}
                {:else}
                    <div>{$format("results_not_found")}</div>
                {/if}
            {/if}
            {#if assetsToAssociate.length > 0}
                <label for="assetsToAssociate" class="mt-3"
                    >{$format("page.tag.assets_to_associate")}:</label
                >
                {#each assetsToAssociate as asset, i}
                    <div>
                        {asset.nickname || asset.name}<i
                            class="fas fa-times btnDeleteAsset float-end"
                            onclick={() =>
                                removeAssetToAssociate(i, assetsToAssociate)}
                        ></i>
                    </div>
                {/each}
            {/if}
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary t-submit-tag-asset-btn"
                >{$format("buttons.save")}</button
            >
            <button
                type="button"
                class="btn btn-default"
                data-bs-dismiss="modal"
            >
                {$format("buttons.cancel")}
            </button>
        </div>
    </div>
</form>

<style>
    .btnDeleteAsset {
        cursor: pointer;
    }
</style>
